import { render, staticRenderFns } from "./BaseInfoInputs.vue?vue&type=template&id=e822e3aa&scoped=true"
import script from "./BaseInfoInputs.vue?vue&type=script&lang=js"
export * from "./BaseInfoInputs.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoInputs.vue?vue&type=style&index=0&id=e822e3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e822e3aa",
  null
  
)

export default component.exports